var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsUser(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12740_27082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.75 9.15308C13.75 11.2281 12.075 12.9031 10 12.9031C7.925 12.9031 6.25 11.2281 6.25 9.15308C6.25 7.07808 7.925 5.40308 10 5.40308C12.075 5.40308 13.75 7.07808 13.75 9.15308Z",
    fill: "#1E1E1E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.4031C20 15.9281 15.525 20.4031 10 20.4031C4.475 20.4031 0 15.9281 0 10.4031C0 4.87808 4.475 0.403076 10 0.403076C15.525 0.403076 20 4.87808 20 10.4031ZM5 17.5906C5.2 17.2581 7.1375 14.1531 9.9875 14.1531C12.825 14.1531 14.775 17.2656 14.975 17.5906C16.1373 16.7868 17.087 15.7127 17.7424 14.4607C18.3978 13.2087 18.7393 11.8163 18.7375 10.4031C18.7375 5.56558 14.825 1.65308 9.9875 1.65308C5.15 1.65308 1.2375 5.56558 1.2375 10.4031C1.2375 13.3781 2.725 16.0156 5 17.5906Z",
    fill: "#1E1E1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12740_27082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.403076)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsUser);
export default __webpack_public_path__ + "static/media/icons_user.1040a5f305dd8d3c976fe72e95645e28.svg";
export { ForwardRef as ReactComponent };